import React, {Dispatch, SetStateAction, useCallback, useState} from "react"
import image from "../../../assets/empty-feature-request.png"
import {IssueDB} from "../../../models/IssueDB.model"
import styles from "./index.module.scss"
import {NewOrEditIssue} from "../NewIssue"

interface EmptyProps {
  db?: IssueDB,
  dbReplCnt?: number,
  setDBReplCnt: Dispatch<SetStateAction<number>>,
}

export const Empty = (props: EmptyProps) => {
  const {db, dbReplCnt, setDBReplCnt} = props
  const [showCreateIssue, setShowCreateIssue] = useState<boolean>(false)

  const onCreateNewIssue = useCallback(() => {
    setShowCreateIssue(true)
  }, [])

  const onCancelCreateNewIssue = useCallback(() => {
    setShowCreateIssue(false)
  }, [])

  if (!db || dbReplCnt === undefined) {
    return null
  }

  return (
    <div className={styles.EmptyBody}>
      <img src={image} alt="No open ticket icon"/>
      <div className={styles.EmptyTitle}>No Open Issues</div>
      <div className={styles.EmptySubTitle}>
        On-chain feature requests are a feature for end users to make feature requests with cryptocurrency incentive.
      </div>
      <button className={styles.CreateNewIssueButton}
              onClick={onCreateNewIssue}
      >
        Create a new issue
      </button>

      <NewOrEditIssue open={showCreateIssue}
                      onClose={onCancelCreateNewIssue}
                      db={db}
                      dbReplCnt={dbReplCnt}
                      setDBReplCnt={setDBReplCnt}
                      isNew={true}
      />
    </div>
  )
}
